const DOMAIN_CACHE: Record<string, Record<string, Record<string | number, string>>> = {};

export async function getDomainGuide(layerUrl: string): Promise<Record<string, Record<string | number, string>>> {
    const base = layerUrl.replace(/\/$/, "");
    if (DOMAIN_CACHE[base]) return DOMAIN_CACHE[base];

    const res = await fetch(`${base}?f=json`);
    if (!res.ok) throw new Error(`Domain fetch failed: ${res.status} ${res.statusText}`);
    const j = await res.json();

    const guide: Record<string, Record<string | number, string>> = {};
    (j.fields || []).forEach((f: any) => {
        const dom = f?.domain?.codedValues;
        if (Array.isArray(dom) && dom.length) {
            const map: Record<string | number, string> = {};
            dom.forEach((cv: any) => { map[cv.code] = cv.name; });
            guide[f.name] = map;
        }
    });

    DOMAIN_CACHE[base] = guide;
    return guide;
}

export function applyDomains(attrs: Record<string, any>, guide: Record<string, Record<string | number, string>>) {
    Object.keys(attrs).forEach((k) => {
        const map = guide[k];
        if (map && attrs[k] != null && map[attrs[k]] != null) {
            attrs[k] = map[attrs[k]];
        }
    });
}
